// Turbo遷移時: splashを差し込まない（初回セッション中のページ遷移対策）
document.addEventListener('turbo:before-render', (e) => {
  const splash = e.detail.newBody.querySelector('#splash')
  if (splash) splash.remove()
})

document.addEventListener('DOMContentLoaded', () => {
  const splash = document.getElementById('splash')
  if (!splash) return

  if (sessionStorage.getItem('splashVisited')) {
    splash.remove()
    return
  }

  sessionStorage.setItem('splashVisited', '1')
  setTimeout(() => splash.remove(), 3100)
})
